/**
 * Null-byte character (U+0000) that must be stripped from payloads.
 * PostgreSQL text columns cannot store null bytes, causing DB write failures.
 */
export const NULL_BYTE_REGEX = /\u0000/g;
